// Реэкспорт: единая реализация в @/entities/application.
// Сигнатура и возвращаемые значения идентичны.
import { useApplicationParticipants } from "@/entities/application";

export function useParticipants(uuid) {
  return useApplicationParticipants(uuid);
}
